/* services */
import { dashboardServices } from '@services'
/* models */
import { dashboardResponse } from '@models'
/* redux */
import { dashboardFail, setDashboard } from './dashboardSlices'

export const getDashboard = () => {
    return async (dispatch: any) => {
        const response = (await dashboardServices()) as dashboardResponse

        if (response.error == true) return dispatch(dashboardFail(response))

        dispatch(setDashboard(response.data))
    }
}
